export const drawerNavigationConstants = {
  SHOW: 'DRAWER_NAVIGATION_SHOW',
  CLOSE: 'DRAWER_NAVIGATION_CLOSE',
}
